module.exports = __webpack_public_path__ + "static/media/barranquilla.a31b795e.jpg";